var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/propose-unapproved-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-17f1b8f4!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/propose-unapproved-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProposeUnapprovedList.vue
// module id = 670
// module chunks = 1